import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import Header from '../components/Header';
import Footer from '../components/Footer';
import { locations } from '../data/locations';
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

// Set up default Leaflet marker icon
const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

const LocationsOverview = () => {
  const navigate = useNavigate();

  const handleLocationSelect = (locationId) => {
    navigate(`/${locationId}`);
  };

  // Set fixed map center coordinates
  const centerCoordinates = [41.905343, -87.657166];

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow max-w-6xl mx-auto p-6 bg-gray-50 rounded-lg shadow-lg">
        <Header />
        
        {/* Map Section */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-green-700">Tree Health Monitoring Locations</h2>
          <p className="text-gray-600 mb-4">
            Select a location to view detailed sensor data from trees across Chicago's universities.
          </p>
          <div className="border rounded-lg overflow-hidden shadow-md">
            <MapContainer 
              center={centerCoordinates}
              zoom={10} 
              style={{ height: "500px" }}
              className="z-0"
            >
              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution='&copy; <a href="https://www.esri.com/">Esri</a>'
              />
              {Object.entries(locations).map(([locationId, location]) => (
                <Marker 
                  key={locationId} 
                  position={location.coordinates}
                >
                  <Popup>
                    <div className="text-center">
                      <h3 className="text-lg font-semibold">{location.name}</h3>
                      <p className="text-sm my-2">{location.description}</p>
                      <p className="text-sm text-gray-600 mb-2">
                        {location.sensors.length} active sensors
                      </p>
                      <button 
                        onClick={() => handleLocationSelect(locationId)}
                        className="mt-2 bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded text-sm transition-colors duration-200"
                      >
                        View Sensors
                      </button>
                    </div>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
        </div>

        {/* Locations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
          {Object.entries(locations).map(([locationId, location]) => (
            <div 
              key={locationId}
              onClick={() => handleLocationSelect(locationId)}
              className="p-6 border rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 cursor-pointer bg-white"
            >
              <h3 className="text-xl font-semibold text-green-700 mb-2">
                {location.name}
              </h3>
              <p className="text-gray-600 mb-4">
                {location.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-500">
                  {location.sensors.length} active sensors
                </span>
                <button className="text-green-600 hover:text-green-700 font-medium text-sm">
                  View Details →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LocationsOverview;